import styled from "styled-components";
import checkIcon from "../images/icon-checkmark.svg";

const PageContainer = styled.div`
  border-radius: 16px;
  background-color: #ffffff;
  padding: 32px 64px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  overflow: hidden;
  height: 640px;

  @media (max-width: 1024px) {
    height: auto;
  }

  @media (max-width: 992px) {
    flex-direction: column;
  }

  @media (max-width: 425px) {
    padding: 16px;
  }
`;

const InformationSection = styled.div`
  max-width: 386px;
  width: 100%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  span {
    border-radius: 12px;
    background-color: #f6f5ff;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: bold;
    color: #8144e5;
    margin-left: 4px;
  }
`;

const Title = styled.div`
  margin-top: 32px;
  font-size: 32px;
  font-weight: bold;
  line-height: 1.25;
  color: #222939;
`;

const Subtitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  color: #6f7582;
`;

const Features = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  color: #222939;
  margin-top: 16px;

  div {
    margin-bottom: 16px;
  }

  div:last-child {
    margin-bottom: unset;
  }
`;

const Feature = styled.div`
  display: flex;
  align-items: center;

  :before {
    content: url(${checkIcon});
    margin-right: 8px;
  }
`;

const Footer = styled.div`
  margin-top: 24px;
  a {
    text-decoration: none;
    display: inline-block;

    :hover {
      color: white;
    }
  }
`;

const ChromeLogo = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.6;
  color: #6f7582;
  margin-bottom: 163px;

  img {
    margin-right: 4px;
  }

  @media (max-width: 992px) {
    margin-bottom: 32px;
  }
`;

const Illustration = styled.div`
  width: 100%;
  text-align: right;
  margin: -100px -64px -32px 90px;
  text-align: right;

  img {
    object-fit: cover;
    max-width: 100%;
    max-height: 100%;
  }

  @media (max-width: 1024px) {
    margin: 0 -64px 0 90px;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: right;
  }
`;
export {
  PageContainer,
  Logo,
  Title,
  Subtitle,
  Features,
  Feature,
  Footer,
  ChromeLogo,
  InformationSection,
  Illustration
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/AliscraperStyle.js